export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_11.0174ad35.jpg";